<script>
import Confirm from '../../../../components/Confirm'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import ItemRegistDialog from './dialogs/ItemRegistDialog'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'DriverMasterItemIndex',
  components: {
    CustomPagination,
    Confirm,
    ItemRegistDialog
  },
  mixins: [],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      targetId: null,
      tableHeaders:[
        { value: 'code', text: 'コード', width: "10%" },
        { value: 'name', text: '廃棄物の種類', width: "35%" },
        { value: 'hierarchy', text: '分類', width: "25%" },
        { value: 'sort_priority', text: '表示順', align: 'right', width: "20%" },
        { text: '編集/削除', value: 'editable', align: 'end', width: "10%" },
      ],
      enableItemDialog: false,
      handle_items: [],
      conditions: {
        type: "industrial",
        limit: 50,
      },
      pagination: {
        current_page: 1,
        total_count: 0,
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isJwMode: 'use_jw_mode',
    }),
    ...mapState('DriverMasterHandleItem', {
      searchCondition: 'condition',
    })
  },

  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }

    Object.assign(this.conditions, this.searchCondition);

    this.perPage = this.conditions.limit
    this.search()
  },
  methods: {
    ...mapActions('DriverMasterHandleItem', {
      fetchHandleItems: 'index',
      deleteHandleItem: 'destroy',
      resetState: 'resetState',
    }),
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterItemEdit', params: { type: this.conditions.type }})
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetId = item.id
      this.enableItemDialog = true
    },
    deleteButtonClickEvent (item) {
      let modalOption = { title: '削除', message: '品目を削除します。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteHandleItem({ id: item.id }).then(() => {
            this.search()
          })
        }
      })
    },
    menuChangeEvent() {
      this.page = 1;
      this.search();
    },
    /**
     * モーダルを閉じる
     */
    closeItemDialog () {
      this.enableItemDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    itemCallback () {
      this.closeItemDialog()
      this.search()
    },
    pageChangeCallback(page) {
      this.page = page;
      this.search()
    },
    perPageChangeCallback (perPage) {
      this.conditions.limit = perPage
      this.page = 1
      this.search()
    },
    search () {
      let params = {
        condition: this.conditions,
        page: this.page,
      }
      this.fetchHandleItems(params).then((content) => {
        this.handle_items = content.handle_items
        this.pagination = content.pagination
      })
    }
  }
}
</script>
<!-- 費目一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-view-module
          </v-icon>
          JWNET取扱品目
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>

      <v-col cols="12" md="6">
        <v-btn-toggle
          v-model="conditions.type"
          class="toggleButton"
          color="info accent-3"
          tile
          light
          mandatory
          rounded
          @change="menuChangeEvent"
        >
          <v-btn
            value="industrial"
            width="150"
          >
            産業廃棄物
          </v-btn>
          <v-btn
            value="specific_industrial"
            width="150"
          >
            特定産業廃棄物<br />
            （放射性物質）
          </v-btn>
          <v-btn
            value="general"
            width="150"
          >
            一般廃棄物
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" md="6" class="text-right">
        <v-btn
          color="primary"
          :disabled="isJwMode"
          @click="addButtonClickEvent"
        >
          品目の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="conditions.limit"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

    <v-sheet class="mt-5 mb-5" rounded>
      <v-data-table
        :headers="tableHeaders"
        :items="handle_items"
        disable-pagination
        :items-per-page="-1"
        disable-sort
        hide-default-footer
      >
        <template v-slot:[`item.created_at`]="{ item }">
          {{ item.created_at | unix_datetime_format }}
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          {{ item.updated_at | unix_datetime_format }}
        </template>
        <template v-slot:[`item.editable`]="{ item }">
          <v-btn
            :icon="$vuetify.breakpoint.mdAndUp"
            :text="$vuetify.breakpoint.smAndDown"
            :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
            @click="editButtonClickEvent(item)"
          >
            <v-icon v-if="$vuetify.breakpoint.mdAndUp">
              mdi-note-edit
            </v-icon>
            <span v-else>編集</span>
          </v-btn>

          <v-btn
            v-if="item.can_delete"
            :icon="$vuetify.breakpoint.mdAndUp"
            :text="$vuetify.breakpoint.smAndDown"
            :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
            @click="deleteButtonClickEvent(item)"
          >
            <v-icon v-if="$vuetify.breakpoint.mdAndUp">
              mdi-trash-can-outline
            </v-icon>
            <span v-else>削除</span>
          </v-btn>
        </template>
      </v-data-table>
    </v-sheet>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="conditions.limit"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

    <!-- /ダイアログ -->
    <item-regist-dialog
      :enable-dialog="enableItemDialog"
      :target-id="targetId"
      @closeEvent="closeItemDialog"
      @registerEvent="itemCallback"
    />
    <!-- ダイアログ -->

    <Confirm ref="confirm" />
  </v-container>
</template>


<style scoped>

</style>
